(() => {
  const SELECTORS = {
    announcement: '.vasumata-premium-announcement-section',
    header: '.section-header',
    premiumHeader: '.vasumata-premium-header'
  };

  let resizeObserver;
  let ticking = false;

  const getElements = () => ({
    announcement: document.querySelector(SELECTORS.announcement),
    header: document.querySelector(SELECTORS.header),
    premiumHeader: document.querySelector(SELECTORS.premiumHeader)
  });

  const updateMeasurements = () => {
    const { announcement, header } = getElements();
    if (!announcement || !header || !document.body.classList.contains('vasumata-sticky-group-enabled')) return;

    const announcementHeight = Math.round(announcement.getBoundingClientRect().height);
    const headerHeight = Math.round(header.getBoundingClientRect().height);

    document.documentElement.style.setProperty('--vasumata-announcement-sticky-height', `${announcementHeight}px`);
    document.documentElement.style.setProperty('--vasumata-header-sticky-height', `${headerHeight}px`);
    document.documentElement.style.setProperty('--vasumata-sticky-stack-height', `${announcementHeight + headerHeight}px`);
  };

  const updateScrollState = () => {
    ticking = false;
    const compactAfter = 40;
    document.body.classList.toggle('vasumata-sticky-group-scrolled', window.scrollY > compactAfter);
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateScrollState);
  };

  const init = () => {
    const { announcement, header } = getElements();
    if (!announcement || !header) return;

    const stickyEnabled = announcement.dataset.stickyGroup !== 'false';
    document.body.classList.toggle('vasumata-sticky-group-enabled', stickyEnabled);
    document.body.classList.toggle('vasumata-sticky-compact-enabled', announcement.dataset.compactOnScroll !== 'false');
    document.body.classList.toggle('vasumata-sticky-glass-enabled', announcement.dataset.glassEffect !== 'false');

    if (!stickyEnabled) {
      document.body.classList.remove('vasumata-sticky-group-scrolled');
      document.documentElement.style.removeProperty('--vasumata-announcement-sticky-height');
      document.documentElement.style.removeProperty('--vasumata-header-sticky-height');
      document.documentElement.style.removeProperty('--vasumata-sticky-stack-height');
      return;
    }

    header.classList.add('shopify-section-header-sticky');
    header.classList.remove('shopify-section-header-hidden');

    resizeObserver?.disconnect();
    resizeObserver = new ResizeObserver(updateMeasurements);
    resizeObserver.observe(announcement);
    resizeObserver.observe(header);

    updateMeasurements();
    updateScrollState();
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
  window.addEventListener('resize', updateMeasurements, { passive: true });
  window.addEventListener('scroll', onScroll, { passive: true });
})();
